var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24.002,
    viewBox: "0 0 21 24.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-delete",
    d: "M2.063-1.5H3.188a.563.563,0,0,0,.563-.562V-12.187a.563.563,0,0,0-.562-.562H2.063a.563.563,0,0,0-.562.563V-2.062A.563.563,0,0,0,2.063-1.5ZM9.75-17.25H5.887L4.293-19.908A2.25,2.25,0,0,0,2.363-21s0,0,0,0H-2.363a2.245,2.245,0,0,0-1.929,1.092L-5.887-17.25H-9.75a.75.75,0,0,0-.75.75v.75a.75.75,0,0,0,.75.75H-9V.75A2.251,2.251,0,0,0-6.75,3H6.75A2.251,2.251,0,0,0,9,.75V-15h.75a.75.75,0,0,0,.75-.75v-.75A.75.75,0,0,0,9.75-17.25Zm-12.2-1.364A.281.281,0,0,1-2.2-18.75H2.2a.281.281,0,0,1,.241.136l.818,1.364H-3.263ZM6.75.75H-6.75V-15H6.75ZM-3.187-1.5h1.125A.563.563,0,0,0-1.5-2.062V-12.187a.563.563,0,0,0-.562-.562H-3.187a.563.563,0,0,0-.562.563V-2.062A.563.563,0,0,0-3.187-1.5Z",
    transform: "translate(10.5 21.002)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelete);
export default __webpack_public_path__ + "static/media/ico-delete.9badcc521640a9bf9d3598109a0e784b.svg";
export { ForwardRef as ReactComponent };